import ItemTileView, { ItemTileViewPropsBase } from './ItemTileView';
import { observer } from 'mobx-react';
import { Image, ImageFit } from 'office-ui-fabric-react/lib/Image';
import { ImageLoadState } from '../../store/schema/FileProviderItemViewState';
import * as React from 'react';

const styles = require('./FileTileView.scss');
const classNames = require('classnames');

export interface FileTileViewProps extends ItemTileViewPropsBase {
    onThumbnailLoaded: () => void;
    onThumbnailError: () => void;
    thumbnailLoadState?: ImageLoadState;
    thumbnailUrl?: string;
}

@observer
export default class FileTileView extends React.Component<FileTileViewProps, {}> {
    render() {
        const {
            thumbnailUrl,
            icon: { large: largeIcon, extraSmall: smallIcon },
            onThumbnailLoaded,
            onThumbnailError,
            thumbnailLoadState,
        } = this.props;

        const isThumbnailAvailable = thumbnailUrl ? true : false;
        return (
            <ItemTileView
                {...this.props as any}
                className={styles.container}
                onSelectedClassName={styles.selected}
                shouldShowTileOverlay={true}>
                <div className={styles.innerContainer} data-is-focusable={false}>
                    {/* The icon for the file if the thumbnail is not available or failed to load thumbnail */}
                    {(!isThumbnailAvailable ||
                        thumbnailLoadState === ImageLoadState.ErrorLoading) && (
                        <div className={styles.fileIconContainer} data-is-focusable={false}>
                            <i
                                className={classNames(largeIcon, styles.fileIcon)}
                                data-is-focusable={false}
                            />
                        </div>
                    )}

                    {/* The thumbnail of the file */}
                    {isThumbnailAvailable && thumbnailLoadState !== ImageLoadState.ErrorLoading && (
                        <div className={styles.fileThumbnailContainer}>
                            <i
                                className={classNames(smallIcon, styles.fileThumbnailOverlayIcon)}
                                data-is-focusable={false}
                            />
                            <Image
                                className={styles.fileThumbnail}
                                src={thumbnailUrl}
                                onError={onThumbnailError}
                                onLoad={onThumbnailLoaded}
                                imageFit={ImageFit.cover}
                                data-is-focusable={false}
                            />
                        </div>
                    )}
                </div>
            </ItemTileView>
        );
    }
}
